import { useEffect, useState } from 'react';
import BarcodesList from './BarcodesList';
import classes from './css/barcodesList.module.css';
import { observer } from 'mobx-react-lite';

const BarcodesMultiList = observer(({ list, setList, getItemsList, item, multiList, disabled }) => {
  const [availableItems, setAvailableItems] = useState([]);

  useEffect(() => {
    const requests = async () => {
      const res = await getItemsList();
      setAvailableItems(res);
    };
    requests();
  }, []);

  list = list?.length ? list : [''];

  const handleInputChange = (id, value, type) => {
    let listTemp = list;

    listTemp[id] = {
      ...listTemp[id],
      [type]: value,
    };

    setList([...listTemp]);
  };

  const handleAddItem = () => {
    let newList = list;
    newList.push({
      id: null,
      value: '',
    });
    setList([...newList]);
  };

  const handleItemRemove = (id) => {
    let listTemp = list;
    listTemp.length > 1 ? listTemp.splice(id, 1) : (listTemp = ['']);

    setList([...listTemp]);
  };

  return (
    <div className={`${classes.itemsContainer} ${item ? classes.fromWidget : ''}`}>
      {list.length ? (
        list.map((item, index) => (
          <BarcodesList
            key={index}
            id={index}
            handleInputChange={handleInputChange}
            handleItemRemove={() => handleItemRemove(index)}
            availableBarcodes={availableItems}
            handleAddItem={handleAddItem}
            isLastItem={list.length === index + 1}
            item={list[index]}
            multiList={multiList}
            disabled={disabled}
          />
        ))
      ) : (
        <BarcodesList
          key={0}
          id={0}
          handleInputChange={handleInputChange}
          handleItemRemove={() => handleItemRemove(0)}
          availableBarcodes={availableItems}
          handleAddItem={handleAddItem}
          isLastItem={true}
          item={list[0]}
          multiList={multiList}
          disabled={disabled}
        />
      )}
    </div>
  );
});

export default BarcodesMultiList;
